import { useNativeApp } from "../Providers/NativeAppProvider";
import {
    isRunningInNativeAndriod,
    isRunningInNativeIOS,
} from "../Helpers/IsRunningInNativeApp";

export enum DEVICE_TYPES {
    "ANDROID_WITH_PLUGIN",
    "IOS_WITH_PLUGIN",
    "ANDROID_WITHOUT_PLUGIN",
    "IOS_WITHOUT_PLUGIN",
    "BROWSER",
}

export function useDeviceType() {
    const { isPluginEnabled } = useNativeApp();
    let deviceType = DEVICE_TYPES.BROWSER;

    switch (true) {
        case isPluginEnabled && isRunningInNativeAndriod():
            deviceType = DEVICE_TYPES.ANDROID_WITH_PLUGIN;
            break;
        case isPluginEnabled && isRunningInNativeIOS():
            deviceType = DEVICE_TYPES.IOS_WITH_PLUGIN;
            break;
        case isRunningInNativeAndriod():
            deviceType = DEVICE_TYPES.ANDROID_WITHOUT_PLUGIN;
            break;
        case isRunningInNativeIOS():
            deviceType = DEVICE_TYPES.IOS_WITHOUT_PLUGIN;
            break;
    }

    return {
        deviceType: deviceType,
    };
}
